import i18n from 'i18n-js';
import { playErrorFeedback, playNotReadyFeedback } from '../utils/scanFeedback';
import * as RootNavigation from '../components/root_navigation';
import {
  setScanPackCurrentOrder,
  setScanPackPrompt,
  setScanPackMainInputFocus,
  getStateValues
} from './scanpackScanningSetters';
import { UpdateOrderStatus } from './orderActions';
import { ShowNotification } from './menuActions';
import { validateConfirmationCode } from '../utils/sharedValidationUtils';
import {
  searchOrderByBarcode,
  checkConfirmationCodeForServiceIssue as checkConfirmationCodeApi
} from '../services/scanpackApiService';

export function showOrderConfirmationIfRequired() {
  return (dispatch, getState) => {
    const { currentOrder, generalSettings } = getStateValues(getState);
    if ((currentOrder?.unscanned_items || []).length === 0) return false;

    const confirmationMode = generalSettings?.conf_req_on_notes_to_packer;
    const required =
      confirmationMode === 'always' ||
      (confirmationMode === 'optional' && !!currentOrder?.note_confirmation);
    if (!required) return false;

    dispatch(setScanPackPrompt(
      true,
      i18n.t('orderConfirmationPopup.orderConfirmationText'),
      'order_confirmation',
      '',
      false
    ));
    return true;
  };
}

export function checkOrderConfirmation() {
  return async (dispatch, getState) => {
    const { prompt, generalSettings, userInfo } = getStateValues(getState);
    const userInput = prompt.input;

    const userCode = userInfo?.confirmation_code;
    const strictCC = generalSettings?.strict_cc;

    const { isMatch, isEmpty, allowBypass } = validateConfirmationCode(userInput, userCode, strictCC);

    if (isMatch || (isEmpty && allowBypass)) {
      dispatch(setScanPackPrompt(false, '', '', '', false));
      dispatch(setScanPackMainInputFocus(true));
    } else if (!isEmpty) {
      dispatch(setScanPackPrompt(
        true,
        i18n.t('orderConfirmationPopup.orderConfirmationMismatch'),
        'order_confirmation',
        '',
        true
      ));
      playErrorFeedback(getState);
    } else {
      playErrorFeedback(getState);
    }
  };
}

export function submitServiceIssue() {
  return (dispatch, getState) => {
    const { prompt, userInfo } = getStateValues(getState);
    const userInput = prompt.input;

    if (!userInfo) return;

    const userCode = userInfo.confirmation_code;

    if (userInfo.role?.add_edit_order_items) {
      if (userInput && userInput === userCode) {
        dispatch(changeOrderStatusToAwaiting());
        return;
      }
      if (userInput) {
        dispatch(searchOrderByInput(userInput, false));
      }
    } else {
      if (userInput !== '') {
        dispatch(checkConfirmationCodeForServiceIssue(userInput));
      }
    }
  };
}

function changeOrderStatusToAwaiting(confirmation_code) {
  return async (dispatch, getState) => {
    const { currentOrder } = getState().scanPackScanning;

    const data = {
      filter: 'all',
      inverted: false,
      limit: 20,
      offset: 0,
      order: 'DESC',
      orderArray: [{id: currentOrder?.id}],
      product_search_toggle: 'true',
      reallocate_inventory: false,
      search: '',
      select_all: false,
      sort: '',
      status: 'awaiting',
      confirmation_code: confirmation_code
    };

    await dispatch(UpdateOrderStatus(data));
    dispatch(setScanPackPrompt(false, '', '', '', false));
    dispatch(showOrderConfirmationIfRequired());
  };
}

function rejectServiceIssueInput(dispatch, getState, codeFound) {
  dispatch(ShowNotification({ value: true, codeFound }));
  playNotReadyFeedback(getState);
  RootNavigation.reset('ScanPack');
}

function searchOrderByInput(input, codeFound = false) {
  return async (dispatch, getState) => {
    try {
      const res = await searchOrderByBarcode(input);

      if (res?.data?.matched && input !== res?.data?.data?.order[0]?.ordernum) {
        dispatch(setScanPackPrompt(false, '', '', '', false));
        dispatch(setScanPackCurrentOrder(res?.data.data?.order[0].scan_hash?.data));
      } else {
        rejectServiceIssueInput(dispatch, getState, codeFound);
      }
    } catch (error) {
      console.error('Error searching order:', error);
      rejectServiceIssueInput(dispatch, getState, codeFound);
    }
  };
}

function checkConfirmationCodeForServiceIssue(confirmation_code) {
  return async (dispatch, getState) => {
    try {
      const res = await checkConfirmationCodeApi(confirmation_code);
      const user = res?.data?.user;

      if (
        user?.confirmation_code === confirmation_code &&
        user?.role?.add_edit_order_items
      ) {
        dispatch(changeOrderStatusToAwaiting(user.confirmation_code));
        return;
      }

      dispatch(searchOrderByInput(confirmation_code, !!user));
    } catch (error) {
      console.error('Error checking confirmation code:', error);
      playNotReadyFeedback(getState);
    }
  };
}
